import { MainSlider } from "component/MainSlider";
import { InnerBanner } from "container/InnerpageBanner";
import { Crumbs } from "molecules/Breadcrumbs";
import { DetailBox } from "molecules/DetailBox";
import { TitleHeading } from "molecules/TitleHeading";
import { TestimonialSection } from "pages/communityImpact/testimonial";
import React, { useEffect } from "react";
import ItemSlider from "./itemSlider";
import { SectionBorder } from "molecules/SectionBorder";
import { SmallHadding } from "molecules/SmallHeadding";
import Divider from "molecules/SimpleBorder/Divider";

import { useDispatch, useSelector } from "react-redux";
import { fetchBlogById ,resetError as resetBlogsError} from "redux-new/features/blogsSlice";
import { useParams } from "react-router-dom";
import IgnoreDangerHtml from "component/TruncatedText/IgnoreDangerHtml";



// media/red_logo.png

export const InsightsDetails = () => {
  const {id} = useParams()
  const dispatch =useDispatch();


  const { singleBlog, loadingSingle, errorSingle } = useSelector((state) => state.blogs);


  useEffect(() => {
    dispatch(fetchBlogById(id));
    return () => {
      dispatch(resetBlogsError()); // Reset error on unmount
    };
  }, [dispatch]);

  // console.log(singleBlog,"singleBlog")



  let htmlContent = '';
  try {
    const parsedContent = JSON.parse(singleBlog?.content_text);
    htmlContent = parsedContent?.target?.value || '';
  } catch (e) {
    // Handle parsing errors if content_text is not valid JSON
    console.error("Error parsing content_text:", e);
    htmlContent = singleBlog?.content_text || '';
  }


  return (
    <>
    <div className="backgroundThm mobileContainer">
   
      <section className="">
        <div className="container pl-0 pr-0">
          <div className="container pl-0">
        <Crumbs />
        </div>
          <div className="grid  ">
            <div className="lg:col-12 md:col-12 sm:col-12  pl-0 w-100">
              {/* <div className="grid align-items-center insight-detail-Head">
                <div className="lg:col-8 md:col-7 sm:col-12 ">
                  <TitleHeading title="Insights Heading" className="m-0" />
                </div>
                <div className="lg:col-4 md:col-5 sm:col-5 text-right">
                  <p className="my-0">Auguest 09,24</p>
                </div>
              </div> */}

              <div className="d-flex align-items-center   pl-0 justify-content-between insight-detail-Head">
              <div className="lg:col-8 md:col-7 sm:col-12 pl-0 ">
                  <TitleHeading title={singleBlog?.title} className="m-0" />
                </div>
              {/* <div className="lg:col-4 md:col-5 sm:col-5 text-right"> */}
                  <p className="my-0">Auguest 09,24</p>
                {/* </div> */}

              </div>
            </div>
            <div className="lg:col-12 md:col-12 sm:col-12  pl-0">
              <img
                // src="media/home_slider/blog-1-400x248 1 (4).png"
                src={ singleBlog?.detail_image || "media/home_slider/blog-1-400x248 1 (4).png"}
                alt=""
                className="img-fluid"
              />
            </div>
          </div>
        </div>
      </section>
      <div className="container pl-0 pr-0">
      <section className="section-padding px-0">
        <div className="container pl-0 pr-0">
          <div className="grid">
            <div className="lg:col-4 md:col-5 sm:col-12 pl-0 ">
              <h3 className="font-normal" style={{fontSize:'14px'}} >Share</h3>
              <ul className="listing line ">
                <li>
                  <a
                    href="http://"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-black-alpha-90 p-0"
                  >
                    <i className="pi pi-facebook  text-2xl"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="http://"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-black-alpha-90 "
                  >
                    <i className="pi pi-envelope text-2xl"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="http://"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-black-alpha-90"
                  >
                    <i className="pi pi-twitter  text-2xl"></i>
                  </a>
                </li>
                <li>
                  <a
                    href="http://"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-black-alpha-90  "
                  >
                    <i className="pi pi-link text-2xl"></i>
                  </a>
                </li>
              </ul>
              <div className="author-box mt-2">
                <h4 className="mb-1" style={{fontSize:'14px'}}>Our People</h4>
                <h5 className="my-1 text-red-600">{singleBlog?.author}</h5>
              </div>
            </div>
            <div className="lg:col-8 md:col-7 sm:col-12 pr-0">
              <div className="grid">
                <div className="lg:col-12 md:col-12 sm:col-12 pr-0 mr-1 width75">
                  <DetailBox className="fontEb font19" details={singleBlog?.description} />
                  <DetailBox className="fontEb font19" details={<IgnoreDangerHtml text={htmlContent}/>}  />
                  {/* <DetailBox  className="fontEb font19" details="Quantum is driven by its Vision statement: “To elevate the professional standards of the Indian realty sector by creating projects that deliver the best value and experience” Quantum imb the professional standards of the Indian realty sector " /> */}
                </div>
                <div className="lg:col-12 md:col-12 sm:col-12 ">
                  <h3 className="font19">Key Features</h3>
                  <ol className=" bulit-listing pl-3">
                    <li className="mb-3 fs-17">
                      To elevate the professional standards of the Indian
                    </li>
                    <li className="mb-3 fs-17">
                      To elevate the professional standards of the Indian
                    </li>
                    <li className="mb-3 fs-17">
                      To elevate the professional standards of the Indian
                    </li>
                    <li className=" fs-17">
                      To elevate the professional standards of the Indian
                    </li>
                  </ol>
                  <div className="rounded-btn ">
                    <a
                      href="#"
                      className="btn  border-1 border-round-3xl border-2 px-3 py-1 border-black-500  no-underline text-2 mt-3 inline-block"
                   style={{border:'1px solid #000'}} >
                      <i className="pi pi-download mr-2"> </i>Download Whitepaper
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
        <div className="container  pl-0 pr-0 "  >
        {/* <SectionBorder className=""/> */}
        <Divider/>
      </div>
      </div>

    


                <div className="container px-0">
      <section className="section-padding pb-4 px-0">
        <div className="container pb-1 pl-0 pr-0">
          <div className="gird">
            <div className="lg:col-12 md:col-12 sm:col-12 py-0 pl-0 pr-1 ">
            <TitleHeading title="Explore More" className="mt-0 mb-3 font27 fontAva noLineHeight" />
            </div>
          </div>
          <ItemSlider />
        </div>
      </section>
      </div>
      </div>
    </>
  );
};
